const defaultOptions = {
  once: true,
  duration: 800,
  easing: "ease-in-out",
};

export const initAOS = (options = {}) => {
  if (typeof window !== "undefined" && window.AOS) {
    window.AOS.init({ ...defaultOptions, ...options });
  }
};

export const refreshAOS = () => {
  if (typeof window !== "undefined" && window.AOS) {
    window.AOS.refresh();
  }
};
